module.exports = __webpack_public_path__ + "img/file.2c83b049.svg";